import keys from 'mout/object/keys'
import max from 'mout/array/max'

export default function getLastLogin(logins) {
  const loginsArray = keys(logins)
  const lastLogin = max(loginsArray, val => parseInt(val))
  return lastLogin
}


// WEBPACK FOOTER //
// ./src/helpers/users/getLastLogin.js